<template>
  <main-layout :selectedMenu="'3'">
    <swiper
      :options="swiperOption"
      ref="mySwiper"
      class="home-banner-swiper"
      v-if="locationList && locationList.length && activityIndex !== 3"
    >
      <!-- slides -->
      <swiper-slide v-for="(item, index) of locationList" :key="index">
        <div
          class="location"
          @mouseenter="on_top_enter"
          @mouseleave="on_top_leave"
        >
          <img
            class="locationImg"
            @click="gotoLocation(item)"
            :src="JSON.parse(item.image)[0].key | imageUrl('', 2320, 732)"
            alt=""
          />
          <div class="advertisement" v-if="item.type == '2'">
            {{ $t("video.广告") }}
          </div>
        </div>
      </swiper-slide>
      <div
        class="swiper-pagination"
        slot="pagination"
        v-if="locationList.length && locationList.length > 1"
      ></div>
    </swiper>
    <div class="container">
      <div class="tabs-wrap">
        <a
          href="javascript:;"
          class="create-activity"
          @click="gotoUrl('/activityLunch')"
          >+ {{ $t("global.创建活动") }}/{{ $t("global.竞赛") }}</a
        >
        <div class="tabs" v-for="(item, index) in contentTab" :key="index">
          <div
            :class="{ choose: activityIndex === index }"
            @click="onChangeIndex(index)"
            class="pointer"
          >
            {{ item }}
          </div>
        </div>
      </div>
      <div class="has-content" v-if="activityDataList.length > 0 || isShowContent">
        <activity-content
          :dataList="activityDataList"
          :otherstyle="false"
          :activityIndex="activityIndex"
          @enterDetail="enterDetail"
        />
        <pages
          :page-size="pagerParams.pageSize"
          :page-count="pagerParams.pageCount"
          :current-page.sync="pagerParams.currentPage"
          :total="pagerParams.total"
          v-if="activityIndex != 3"
          @current-page-changed="OnCurrentPageChanged"
        ></pages>
      </div>
      <content-empty
        v-else
        :content="`${$t('global.暂时没有任何活动')}，${$t('global.敬请期待')}`"
      ></content-empty>
      <ActivityDialog @close="showDialog = false" v-if="showDialog" />
      <div class="popAu" v-if="showDialog1">
        <div class="popAuBox">
          <p class="title">
            {{$t('works.企业账户认证')}}
            <span @click="closePopup"></span>
          </p>
          <p class="line"></p>
          <p class="text">
            {{$t('works.您的账户尚未进行企业认证，认证审核通过后即可发布活动，是否要去认证？')}}
          </p>
          <p class="auButton" @click="gotoAu">{{$t('works.立即认证')}}</p>
        </div>
      </div>
    </div>
  </main-layout>
</template>

<script>
import ActivityDialog from "@/pages/dialog/ActivityDialog";
import MainLayout from "@/layouts/MainLayout";
import pages from "@/components/pages.vue";
import ActivityContent from "@/components/activity/ActivityContent";
import ContentEmpty from "@/components/ContentEmpty";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
// import ActivityLunch from '@/pages/activity/ActivityLunch'

export default {
  name: "activity",
  components: {
    MainLayout,
    pages,
    ActivityContent,
    ContentEmpty,
    // ActivityLunch
    ActivityDialog,
    swiper,
    swiperSlide,
  },

  data() {
    return {
      activityIndex: 0,
      isShowContent: false,
      contentTab: [
        this.$t("global.全部"),
        this.$t("global.线上活动"),
        this.$t("global.线下活动"),
        this.$t("global.竞赛"),
      ],
      enabledSort: [true, false, false, false],
      activityContentOption: {
        type: undefined,
        orderBy: 0,
        pageIndex: 1,
        pageSize: 11,
      },
      activityDataList: [],
      pagerParams: {
        pageSize: 12,
        pageCount: 5,
        currentPage: 1,
        total: 1,
      },
      showDialogForm: false,
      showDialog: false,
      showDialog1: false,
      locationList: [],
      activeIndex: null,
      swiperOption: {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        speed: 1000,
        effect: "fade",
        pagination: {
          el: ".swiper-pagination", //分页器作用对象
          clickable: true, //分页器小圆点是否可点击
        },
        on: {
          slideChangeTransitionEnd: () => {
            let swiper = this.$refs.mySwiper.swiper;
            let activeIndex = swiper.activeIndex;
            this.activeIndex = activeIndex;
          },
        },
      },
    };
  },
  watch: {
    $route: function () {
      if (this.$route.query.type) {
        this.getInfo();
      }
      this.getData();
      this.changeIndexWithRoute();
    },
    activeIndex(val) {
      this.locationShow(this.locationList[val]);
    },
  },
  destroyed() {
    document.body.style.overflow = "";
  },
  methods: {
    getInfo() {
      if (localStorage.getItem("auth_token")) {
        this.$http.get("/api/u/info/get").then((response) => {
          let data = response.data;
          if (data.userType == 2 && data.isCertification == 1) {
            this.showDialog = true;
            document.body.style.overflow = "hidden";
          } else {
            this.showDialog1 = true;
            document.body.style.overflow = "hidden";
          }
        });
      } else {
        this.$router.push(
          "/login?redirecturl=" +
            window.location.pathname +
            window.location.search
        );
      }
    },
    closePopup() {
      document.body.style.overflow = "";
      this.showDialog1 = false;
    },
    gotoAu() {
      this.$router.push("/ApplyIdentification");
    },
    on_top_enter() {
      this.$refs.mySwiper.swiper.autoplay.stop();
    },
    on_top_leave() {
      this.$refs.mySwiper.swiper.autoplay.start();
    },
    getLocation() {
      this.$http.get("/api/operations/list/5").then((res) => {
        if (res.code === "OK") {
          this.locationList = res.data;
          this.locationShow(this.locationList[0]);
        }
      });
    },
    locationClick(item) {
      let params = {
        locationId: item.locationId,
        sort: item.sort,
        configId: item.id,
      };
      this.$http.post("/api/operations/click", params).then((res) => {
        //运营位点击
      });
    },
    locationShow(item) {
      if (item.isFunc) {
        return;
      }
      let params = {
        locationId: item.locationId,
        sort: item.sort,
        configId: item.id,
      };
      this.$http.post("/api/operations/show", params).then((res) => {
        //运营位展示
        item.isFunc = true;
      });
    },
    gotoLocation(item) {
      this.locationClick(item);
      this.openLocatione(item);
    },
    gotoUrl() {
      this.getInfo();
    },
    onChangeIndex(index) {
      this.activityIndex = index;
      switch (index) {
        case 0:
          this.$router.push({ path: "/activity/all" });
          break;
        case 1:
          this.$router.push({ path: "/activity/online" });
          break;
        case 2:
          this.$router.push({ path: "/activity/offline" });
          break;
        case 3:
          this.$router.push({ path: "/activity/match" });
          break;
      }
    },
    changeIndexWithRoute() {
      switch (this.$route.params.category) {
        case "online":
          this.activityIndex = 1;
          this.buriedPoint(26,0)
          break;
        case "offline":
          this.activityIndex = 2;
          this.buriedPoint(27,0)
          break;
        case "match":
          this.buriedPoint(33,0)
          this.activityIndex = 3;
          break;
        default:
          this.activityIndex = 0;
          this.buriedPoint(28,0)
      }
    },
    changeSort(index) {
      this.enabledSort.fill(false);
      this.enabledSort[index] = true;
      this.pagerParams.currentPage = 1;
      this.getData({ orderBy: index + 1 });
    },

    /**
     * @param {object} options = {type, orderBy, pageIndex, pageSize}
     */
    getData(options) {
      this.setActivityContentTypeByRoute();
      this.activityContentOption = Object.assign(
        this.activityContentOption,
        options
      );
      let o = this.activityContentOption;
      if (this.$route.params.category&&this.$route.params.category !== 'match') {
          this.getDataList(
          o.type,
          o.orderBy,
          this.pagerParams.currentPage,
          this.pagerParams.pageSize
        );
      } else {
        this.isShowContent = true;
      }
    },
    getDataList(type, orderBy, pageIndex, pageSize) {
      type = type === 3 ? 2 : type;
      this.$http
        .get("/api/activity/indexList", {
          params: {
            type: type,
            orderBy: orderBy,
            pageIndex: pageIndex,
            pageSize: pageSize,
          },
        })
        .then((data) => {
          let d = data.data;
          this.activityDataList = d.list;
          this.activityDataList.map(function (item) {
            item.tags = eval(item.tags);
          });
          this.pagerParams.currentPage = d.pageIndex;
          this.pagerParams.total = d.totalRecord;
        });
    },
    OnCurrentPageChanged(val) {
      this.pagerParams.currentPage = val;
      this.getData();
    },
    setActivityContentTypeByRoute() {
      switch (this.$route.path) {
        case "/activity/all":
          this.activityContentOption.type = undefined;
          document.title = `${this.$t("global.活动")} | MANA`;
          break;
        case "/activity/online":
          this.activityContentOption.type = 1;
          document.title = `${this.$t("global.线上活动")} | MANA`;
          break;
        case "/activity/offline":
          this.activityContentOption.type = 2;
          document.title = `${this.$t("global.线下活动")} | MANA`;
          break;
        case "/activity/match":
          this.activityContentOption.type = 3;
          document.title = `${this.$t("global.竞赛")} | MANA`;
          break;
      }
    },

    enterDetail: function ({ id, category }) {
      switch (category) {
        case 1:
        case 2:
          this.$router.push({ path: `/activityDetail/${id}` });
          break;
        case 3:
          this.$router.push({ path: `/activityMatch/${id}/introduction` });
          break;
      }
    },
  },

  created() {
    if (this.$route.query.type) {
      this.getInfo();
    }
    this.getLocation();
    this.getData();
    this.changeIndexWithRoute();
  },
};
</script>
<style>
.swiper-pagination {
  bottom: 12px !important;
}
.swiper-pagination-bullet {
  width: 6px;
  height: 6px;
  opacity: 1;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 100%;
}
.swiper-pagination-bullet-active {
  background: #ffffff;
}
</style>
<style lang="stylus" scoped>
.location {
  width: 1160px;
  height: 366px;
  margin: 20px auto 0;
  position: relative;
  cursor: pointer;

  .locationImg {
    width: 100%;
    height: 100%;
    display: inline-block;
  }

  .advertisement {
    position: absolute;
    left: 0;
    bottom: 0;
    padding: 0 4px;
    height: 16px;
    background: rgba(51, 51, 51, 0.4);
    border-radius: 0px 6px 0px 0px;
    line-height: 16px;
    text-align: center;
    font-size: 10px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.8);
  }
}

.pointer {
  cursor: pointer;
}

.container {
  width: 1160px !important;
  min-height: calc(100vh - 243px);
}

.order {
  display: flex;
  /* width 16rem */
  overflow: hidden;
  color: #777777;
  margin-top: 0.5rem;
  line-height: 0.16rem;
  font-size: 0.16rem;

  .sort {
    color: #0060ff;
    font-weight: bold;
  }

  >div {
    cursor: pointer;
    margin-left: 0.3rem;
    font-size: 0.16rem;
    line-height: 0.17rem;

    &:first-child {
      margin-left: 0;
    }
  }

  img {
    width: 0.16rem;
    margin-top: -0.04rem;
  }

  span {
    display: inline-block;
    margin-left: 0.1rem;
  }
}

.tabs-wrap {
  width: 1160px;
  padding: 0 20px;
  height: 60px;
  line-height: 60px;
  background-color: #ffffff;
  margin-top: 30px;
  font-size: 18px;
  box-sizing: border-box;

  .tabs {
    color: #777777;
    display: inline-block;

    >div {
      margin-right: 50px;
      flex: none;
    }

    .choose {
      border-bottom: 2px solid #333333;
      color: #333;
      font-weight: bold;
    }
  }
}

.banner {
  width: 100%;
  height: 6rem;
  background: url('/static/identification/Header05.png') no-repeat;
  background-size: 100%;
}

.orderby-icon-time {
  display: inline-block;
  width: 0.16rem;
  height: 0.18rem;
  background: url('/static/explore/time.png') no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
}

.orderby-icon-visit {
  display: inline-block;
  width: 0.19rem;
  height: 0.18rem;
  background: url('/static/explore/visit.png') no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
  margin-left: 0.35rem;
}

.orderby-icon-zan {
  display: inline-block;
  width: 0.16rem;
  height: 0.18rem;
  background: url('/static/explore/zan.png') no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
  margin-left: 0.35rem;
}

.orderby-icon-comment {
  display: inline-block;
  width: 0.16rem;
  height: 0.18rem;
  background: url('/static/explore/comment.png') no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
  margin-left: 0.35rem;
}

.order .active-time {
  background: url('/static/explore/focusTime.png') no-repeat center center;
  background-size: contain;
}

.order .active-visit {
  background: url('/static/explore/focusVisit.png') no-repeat center center;
  background-size: contain;
}

.order .active-zan {
  background: url('/static/explore/focusZan.png') no-repeat center center;
  background-size: contain;
}

.order .active-comment {
  background: url('/static/explore/focusComment.png') no-repeat center center;
  background-size: contain;
}

.create-activity {
  float: right;
  height: 40px;
  margin-top: 10px;
  padding: 0 10px;
  line-height: 40px;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  background: #3664ED;
  border-radius: 4px;
}

.popAu {
  position: fixed;
  width: 100%;
  height: 100vh;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 9999;

  .popAuBox {
    width: 380px;
    height: 240px;
    background: rgba(255, 255, 255, 1);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    .title {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      height: 60px;
      line-height: 60px;
      padding: 0 20px;
      position: relative;

      span {
        background: url('/static/close_btn@2x.png');
        background-size: 100%;
        width: 13px;
        height: 13px;
        position: absolute;
        right: 20px;
        top: 23px;
        cursor: pointer;
      }
    }

    .line {
      height: 1px;
      width: 100%;
      background: #E0E0E0;
    }

    .text {
      height: 48px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 24px;
      padding: 0 20px;
      margin: 30px 0 36px 0;
    }

    .auButton {
      width: 136px;
      height: 40px;
      background: #2026CC;
      margin: 0 auto;
      text-align: center;
      line-height: 40px;
      font-size: 16px;
      font-weight: 600;
      color: #FFFFFF;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/Activity.vue